import { render, staticRenderFns } from "./gobuy.vue?vue&type=template&id=206c2b3a&scoped=true"
import script from "./gobuy.vue?vue&type=script&lang=js"
export * from "./gobuy.vue?vue&type=script&lang=js"
import style0 from "./gobuy.vue?vue&type=style&index=0&id=206c2b3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206c2b3a",
  null
  
)

export default component.exports